import { Tab } from 'react-dsgov';
import { useEffect, useState } from 'react';
import { IDeclaracaoHastaPublica, IDeclaracaoPrimeiroAdquirente } from '../../interfaces/IDeclaracoes';
import { NaoIniciadaTable } from '../declaracoesTables/naoIniciadaTable/naoIniciadaTable';
import { ExistentesTable } from '../declaracoesTables/existenteTable/existenteTables';
import { mesesSemDeclaracoes } from '../../utils/mesesSemDeclaracoes';
import { getMesDeclaracao } from '../../utils/anoMesDeclaracao';

interface ICustomTab {
  declaracoesData: (IDeclaracaoPrimeiroAdquirente | IDeclaracaoHastaPublica)[];
  isDeclaracoesLoading: boolean;
  declaracaoType: 'primeiro-adquirente' | 'hasta-publica';
  ano: string;
}

function CustomTab({ declaracoesData, isDeclaracoesLoading, declaracaoType, ano }: Readonly<ICustomTab>) {
  const [emPreenchimentoData, setEmPreenchimentoData] = useState<
    (IDeclaracaoPrimeiroAdquirente | IDeclaracaoHastaPublica)[]
  >([]);
  const [entregueData, setEntregueData] = useState<(IDeclaracaoPrimeiroAdquirente | IDeclaracaoHastaPublica)[]>([]);
  const [naoIniciadaMonths, setNaoIniciadaMonths] = useState<number[]>(Array.from({ length: 12 }, (_, i) => i + 1));

  const getIsDeclaracaoEmPreenchimento = (declaracao: IDeclaracaoPrimeiroAdquirente | IDeclaracaoHastaPublica) => {
    return declaracao.statusDeclaracao === 0 || declaracao.statusDeclaracao > 4;
  };

  const getIsDeclaracaoEntregue = (declaracao: IDeclaracaoPrimeiroAdquirente | IDeclaracaoHastaPublica) => {
    return declaracao.statusDeclaracao > 0 && declaracao.statusDeclaracao < 5;
  };

  useEffect(() => {
    if (declaracoesData) {
      setEmPreenchimentoData(declaracoesData.filter((declaracao) => getIsDeclaracaoEmPreenchimento(declaracao)));
      setEntregueData(declaracoesData.filter((declaracao) => getIsDeclaracaoEntregue(declaracao)));
      setNaoIniciadaMonths(mesesSemDeclaracoes(declaracoesData, getMesDeclaracao(ano)));
    }
  }, [declaracoesData, ano]);

  const declaracaoOperationLabel =
    declaracaoType === 'primeiro-adquirente'
      ? {
          field: 'valorTotalAquisicoes',
          label: 'Valor Total de Aquisição',
        }
      : {
          field: 'valorTotalArrematacoes',
          label: 'Valor Total de Arrematação',
        };

  return (
    <Tab density='small'>
      <Tab.Content title='Não iniciada' icon='fas fa-file'>
        <NaoIniciadaTable months={naoIniciadaMonths} isLoading={isDeclaracoesLoading} page={declaracaoType} ano={ano} />
      </Tab.Content>

      <Tab.Content title='Em Preenchimento' icon='fas fa-file-signature'>
        <ExistentesTable
          data={emPreenchimentoData}
          headers={[
            { field: 'tipoDeclaracao', label: 'Tipo' },
            { field: 'declarante', label: 'Declarante' },
            { field: 'exercicio', label: 'Exercício' },
            { field: 'acao-editar', label: 'Ação' },
          ]}
          isLoading={isDeclaracoesLoading}
          tab='Em Preenchimento'
          page={declaracaoType}
        />
      </Tab.Content>

      <Tab.Content title='Entregue' icon='fas fa-file-upload'>
        <ExistentesTable
          data={entregueData}
          headers={[
            { field: 'tipoDeclaracao', label: 'Tipo' },
            { field: 'status', label: 'Status' },
            { field: 'numeroRecibo', label: 'Recibo' },
            { field: 'exercicio', label: 'Exercício' },
            { field: 'dataRecibo', label: 'Data de Entrega' },
            declaracaoOperationLabel,
            { field: 'acao-visualizar', label: 'Ação' },
          ]}
          isLoading={isDeclaracoesLoading}
          tab='Entregue'
          page={declaracaoType}
        />
      </Tab.Content>
    </Tab>
  );
}

export default CustomTab;
